import React, { useState, useCallback, useMemo } from 'react'
import { nanoid } from 'nanoid'
import { Input, Button } from 'antd'
import {
  SvgCloseIcon,
  SvgMoreIcon,
} from '../../../../../../../components/svg/SvgComponents'

import styles from './RestrictedSubmissionsInput.module.css'
import { useContext } from 'react'
import {
  addRestrictedSubmissions,
  updateRestrictedSubmissions,
  deleteRestrictedSubmissions,
} from '../../../../../../../services/api'

import DescriptionVisibleInput from '../DescriptionVisibleInput/DescriptionVisibleInput'
import { observer } from 'mobx-react-lite'
import AvatarRoles from '../../../../../../../components/AvatarRoles/AvatarRoles'

import { BuilderContext } from '../../../../store/store.Builder'

const RestrictedSubmissionsInput = observer(({ value = [], onChange }) => {
  const builderContext = useContext(BuilderContext)
  return (
    <div className={styles.container}>
      <div className={styles.switch}>
        <DescriptionVisibleInput value={value} onChange={onChange} />
      </div>
      <div></div>
      {value ? (
        <div className={styles.rules}>
          <AvatarRoles
            url_code={builderContext.url_code}
            title={'Personnes pouvant répondre au formulaire.'}
            userFullName={builderContext.userFullName}
            userUsername={builderContext.userUsername}
            dataAPI={builderContext.RestrictedSubmissionsDataAPI}
            onAddUser={addRestrictedSubmissions}
            onEditUser={updateRestrictedSubmissions}
            onDeleteUser={deleteRestrictedSubmissions}
            isAdmin={builderContext.isAdmin}
          />
        </div>
      ) : null}
    </div>
  )
})

export default RestrictedSubmissionsInput
